// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__45Zgg","bottom":"Tooltip_bottom__F7KrD","top":"Tooltip_top__QwbmJ","show":"Tooltip_show__2x4CL"};